module.exports = __webpack_public_path__ + "static/media/Facebook.21e00bab.svg";